// extracted by mini-css-extract-plugin
export default {"footnote":"TableFootnote_footnote__mJiFC"};